import React, { useEffect, useRef } from "react";
import { AuditTopbar, AuditFooter } from "@/components/audit/AuditChrome";
import { AuditHero } from "@/components/audit/AuditHero";
import { AuditSocialProof } from "@/components/audit/AuditSocialProof";
import { AuditFunnel } from "@/components/audit/AuditFunnel";
import { initMetaPixel, trackPixel } from "@/lib/metaPixel";
import { useSeo } from "@/hooks/useSeo";
import { scrollToTarget } from "@/components/SmoothScroll";

const PAGE_TITLE = "Free Website Audit for Building Firms | Jay Alminshawi";
const PAGE_DESCRIPTION =
  "A free, personally recorded website audit for UK building firms — renovation, construction, new build, kitchen & bathroom and extension companies. I'll review your design, user experience and enquiry journey and show you what's holding your website back.";

const AuditPage = () => {
  const funnelRef = useRef(null);

  useSeo({ title: PAGE_TITLE, description: PAGE_DESCRIPTION, path: "/audit" });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    initMetaPixel();
    trackPixel("PageView");
  }, []);

  const startFunnel = () => {
    scrollToTarget(funnelRef.current, 0);
    setTimeout(() => document.getElementById("first_name")?.focus({ preventScroll: true }), 750);
  };

  return (
    <main data-testid="audit-page" className="relative min-h-screen bg-[#09090b] text-white font-jakarta antialiased">
      <AuditTopbar />
      <AuditHero onStart={startFunnel} />
      <AuditSocialProof />
      <AuditFunnel ref={funnelRef} onSuccess={(lead) => trackPixel("Lead", { content_name: "Website Audit", content_category: lead.company })} />
      <AuditFooter />
    </main>
  );
};

export default AuditPage;
